module.exports = __webpack_public_path__ + "static/media/defaultModelAvatar.7fded07d.png";